module.exports = __webpack_public_path__ + "static/media/attraction1.5456e4e2.jpg";